import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PageHeader from "../Components/PageHeader";
import Select from "react-select";

const PhysicianAvailablity = () => {
	const specializationOptions = [
		{ value: "Monday", label: "Monday" },
		{ value: "Tuesday", label: "Tuesday" },
		{ value: "Wednesday", label: "Wednesday" },
	];

	const [selectedSpecializations, setSelectedSpecializations] =
		useState("Select days");

	const handleChange = (selectedOptions) => {
		setSelectedSpecializations(selectedOptions);
	};
	return (
		<>
			<Header />
			<PageHeader pagename="SignUp" />
			<section className="signup availablity">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="signup-wrappper">
								<h2 className="main-heading-font dark-color  level-2 text-center mt-3  mb-4">
									Show your Availablity
								</h2>
								<form>
									<div className="row mb-5">
										<div className="col-lg-11 mx-auto">
											<div className="select-days">
												<h4 className="level-5 main-heading-font dark-color">
													Select Days
												</h4>
												<Select
													isMulti
													name="specializations"
													isSearchable={false}
													options={specializationOptions}
													className="basic-multi-select"
													classNamePrefix="select"
													onChange={handleChange}
													value={selectedSpecializations}
													placeholder="Select days"
												/>
												<div className="row mt-5">
													<div className="col-lg-4 form-group">
														<h5 class="main-heading-font dark-color level-6 mb-2">
															Select Days
														</h5>
														<div className="custom-select-wrapper mt-3">
															<select className="form-control custom-select">
																<option value="">Mon</option>
																<option value="Tue">Tue</option>
																<option value="Wed">Wed</option>
																<option value="Thur">Thur</option>
																<option value="Fri">Fri</option>
																<option value="Sat">Sat</option>
																<option value="Sun">Sun</option>
															</select>
														</div>
														<div className="custom-select-wrapper mt-3">
															<select className="form-control custom-select">
																<option value="Tue">Tue</option>
																<option value="Wed">Wed</option>
																<option value="Thur">Thur</option>
																<option value="Fri">Fri</option>
																<option value="Sat">Sat</option>
																<option value="Sun">Sun</option>
															</select>
														</div>
														<div className="custom-select-wrapper mt-3">
															<select className="form-control custom-select">
																<option value="Wed">Wed</option>
																<option value="Thur">Thur</option>
																<option value="Fri">Fri</option>
																<option value="Sat">Sat</option>
																<option value="Sun">Sun</option>
															</select>
														</div>
													</div>
													<div className="col-lg-4 form-group">
														<h5 class="main-heading-font text-center dark-color level-6 mb-2">
															Start
														</h5>
														<div className="custom-select-wrapper mt-3">
															<select className="form-control custom-select">
																<option value="">00:00 AM</option>
															</select>
														</div>
														<div className="custom-select-wrapper mt-3">
															<select className="form-control custom-select">
																<option value="">00:00 AM</option>
															</select>
														</div>
														<div className="custom-select-wrapper mt-3">
															<select className="form-control custom-select">
																<option value="">00:00 AM</option>
															</select>
														</div>
													</div>
													<div className="col-lg-4 form-group">
														<h5 class="main-heading-font dark-color text-center level-6 mb-2">
															End
														</h5>
														<div className="custom-select-wrapper mt-3">
															<select className="form-control custom-select">
																<option value="">00:00 PM</option>
															</select>
														</div>
														<div className="custom-select-wrapper mt-3">
															<select className="form-control custom-select">
																<option value="">00:00 PM</option>
															</select>
														</div>
														<div className="custom-select-wrapper mt-3">
															<select className="form-control custom-select">
																<option value="">00:00 PM</option>
															</select>
														</div>
													</div>
												</div>
											</div>
											<div className="row">
												<div className="col-lg-12">
													<Link
														class="btn wrapper-btn-main w-100 log-in mt-4 level-7 primary-regular-font text-decoration-none"
														to="/physician-personal-info"
													>
														<span class="bg-wrapper w-100">Submit</span>
													</Link>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianAvailablity;
